import { useState, } from "react";
import {
    getAllGRNs,
    deleteGRNByID,
    createGRNService,
    getGRNByID,
    updateGRNByID,
} from "../../../Services/grnService";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constant";

export const useGRN = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        search: null,
        mrr: null,
        warehouse: null,
    });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const onPageChange = (newPage) => setPage(newPage);
    const onPageSizeChange = (newSize) => {
        setRowsPerPage(newSize);
        setPage(1);
    };

    const fetchGRNs = async (params) => {
        setLoading(true);
        let data = null;
        try {
            const response = await getAllGRNs({
                ...filters,
                ...params,
                limit: rowsPerPage,
                offset: (page - 1) * rowsPerPage,
            });
            if (response.status === 200) {
                data = response.data?.results;
                setTotalPages(Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage)));
            } else {
                toast.error(extractErrorMessage(response) || TOAST_MESSAGES.FETCH_GRN_FAILED);
            }
        } catch (error) {
            toast.error(extractErrorMessage(error) || TOAST_MESSAGES.FETCH_GRN_FAILED);
        } finally {
            setLoading(false);
            return data;
        }
    }; 

    //delete grn by id
    const deleteGRNs = async (id) => {
        setLoading(true);
        let success = false;
        try {
            const response = await deleteGRNByID(id);
            if (response.status === 204) {
                toast.success(TOAST_MESSAGES.DELETE_GRN_SUCCESS);
                success = true;
            } else {
                toast.error(extractErrorMessage(response) || TOAST_MESSAGES.DELETE_GRN_FAILED);
            }
        } catch (error) {
            toast.error(extractErrorMessage(error) || TOAST_MESSAGES.DELETE_GRN_FAILED);
        } finally {
            setLoading(false);
            return success;
        }
    };

    // createGRN
    const createGRN = async (payload) => {
        setLoading(true);
        let data = null;
        try {
            const response = await createGRNService(payload)
            if (response.status === 201) {
                data = response?.data;
                toast.success(TOAST_MESSAGES.GRN_CREATED);
            } else {
                toast.error(extractErrorMessage(response) || TOAST_MESSAGES.GRN_CREATION_FAILED);
            }
        } catch (error) {
            toast.error(extractErrorMessage(error) || TOAST_MESSAGES.GRN_CREATION_FAILED);
        } finally {
            setLoading(false);
            return data;
        }
    };

    //get grn by id
    const fetchGRNById = async (id) => {
        setLoading(true);
        let data = null;
        try {
            const response = await getGRNByID(id);
            if (response.status === 200) {
                data = response.data;
                toast.success(TOAST_MESSAGES.GRN_DETAIL_FETCHED);
            } else {
                toast.error(extractErrorMessage(response) || TOAST_MESSAGES.FETCH_GRN_FAILED);
            }
        } catch (error) {
            toast.error(extractErrorMessage(error) || TOAST_MESSAGES.FETCH_GRN_FAILED);
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updateGRN = async (id, payload) => {
        setLoading(true);
        let data = null;
        try {
            const response = await updateGRNByID(id, payload);
            if (response.status === 200) {
                data = response.data;
            } else {
                toast.error(extractErrorMessage(response) || TOAST_MESSAGES.GRN_UPDATING_FAILED);
            }
        } catch (error) {
            toast.error( extractErrorMessage(error) || TOAST_MESSAGES.GRN_UPDATING_FAILED);
        } finally {
            setLoading(false);
            return data;
        }
    };

    return {
        loading,
        filters,
        setFilters,
        page,
        totalPages,
        rowsPerPage,
        onPageChange,
        onPageSizeChange,
        fetchGRNs,
        deleteGRNs,
        createGRN,
        fetchGRNById,
        updateGRN,
    };
};
